import { render, staticRenderFns } from "./agentInfoStyle.vue?vue&type=template&id=2b2a23ed&scoped=true"
import script from "./agentInfoStyle.vue?vue&type=script&lang=js"
export * from "./agentInfoStyle.vue?vue&type=script&lang=js"
import style0 from "./agentInfoStyle.vue?vue&type=style&index=0&id=2b2a23ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a23ed",
  null
  
)

export default component.exports